import { Box, Button, Modal, SxProps, Theme, Typography } from '@mui/material';
import { CSSProperties, PropsWithChildren } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import './styles.css';

interface Props extends PropsWithChildren {
  title?: string;
  open: boolean;
  onClose: () => void;
  onDone?: () => void;
}

const style: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '5px',
  boxShadow: 24,
  maxHeight: '80%',
  overflowY: 'auto',
};

const closeButtonStyle: CSSProperties = {
  position: 'relative',
  top: '0',
  left: '0',
};

function EditContentModal({
  title,
  onClose,
  open,
  onDone: onDoneProp,
  children,
}: Props) {
  const onDone = async () => {
    onDoneProp?.();
    onClose();
  };

  if (!open) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="edit-content-modal"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        width={{
          xs: '90%',
          md: '720px',
        }}
        sx={style}>
        <Box
          className="modal-header"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          borderRadius="5px 5px 0 0"
          boxSizing="border-box">
          <button
            className="close-modal"
            type="button"
            onClick={onClose}
            style={closeButtonStyle}>
            <CloseIcon />
          </button>

          <Button
            variant="contained"
            sx={{
              paddingX: 5,
              paddingY: 1.25,
            }}
            onClick={onDone}>
            Done
          </Button>
        </Box>

        <Box padding={2}>
          {!!title && (
            <Typography variant="h2" marginBottom={2.5}>
              {title}
            </Typography>
          )}

          <Box border="1px solid #F2F2F2" width="100%">
            {children}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default EditContentModal;
